<script setup lang="ts">
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import { useDonorPlan } from '@/composables/useDonorPlan'
import { useUpgradeModal } from '@/composables/useUpgradeModal'
import { useClaimTaxBack } from '@/composables/useClaimTaxBack'
import { consumeNavFeedback } from '@/composables/useDashboardNavFeedback'
import DashboardDataLoading from '@/components/dashboard/ui/DashboardDataLoading.vue'
import ClaimChecker from '@/components/dashboard/claim/ClaimChecker.vue'
import ClaimGuide from '@/components/dashboard/claim/ClaimGuide.vue'

const store = useStore()
const { isPlanKnown, isPaid } = useDonorPlan()
const { openUpgradeModal } = useUpgradeModal()
const { isReady, markVisited } = useClaimTaxBack()

onMounted(() => {
  // Other dashboard pages clear these; without them a Vite HMR can leave this
  // route on the shell spinner, and isPlanKnown can stay false forever because
  // this page never fetched GET /me/plan itself.
  consumeNavFeedback()
  store.commit('SET_LOADING', false)
  if (!isPlanKnown.value) {
    void store.dispatch('fetchDonorPlan')
  }
  // Clears the sidebar "New" marker; fire-and-forget so paint is not blocked.
  void markVisited()
})
</script>

<template>
  <div>
    <DashboardDataLoading v-if="!isPlanKnown || !isReady" />
    <div v-else class="sa-page-stack sa-claim-page">
      <div class="sa-claim-disclaimer" role="note">
        <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            clip-rule="evenodd"
          />
        </svg>
        <p>{{ $t('Dashboard.ClaimTaxBack.Disclaimer') }}</p>
      </div>

      <!-- Free: the checker. Estimate before price, always. -->
      <ClaimChecker v-if="!isPaid" @upgrade="openUpgradeModal" />

      <!-- Paid: reconcile donations, capture tax details, route to HMRC. -->
      <ClaimGuide v-else />
    </div>
  </div>
</template>
